<template>
  <main>
    <navigation></navigation>
    <div class="w-full px-4 sm:px-6 lg:px-8">
      <router-view></router-view>
    </div>
  </main>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  components: {
    Navigation,
  },
}
</script>
